import { Typography } from "@mui/material";
import { Column, MedicationStrength } from "src/api/types";

export const useColumns = (): Column<MedicationStrength>[] => {
  return [
    {
      id: "strength",
      label: "Strength",
      minWidth: 80,
      align: "center",
      orderable: false,
      format: (row) => `${row.strength_value} ${row.strength_unit}`,
      render: (row) => (
        <Typography>{`${row.strength_value} ${row.strength_unit}`}</Typography>
      ),
    },
    {
      id: "reference",
      label: "Reference",
      minWidth: 80,
      align: "center",
      orderable: false,
      format: (row) => row.reference_amount.toString(),
      render: (row) => (
        <Typography>
          {`${row.reference_amount} ${row.reference_unit}`}
        </Typography>
      ),
    },
  ];
};
